import Typography from '@common/Typography';
import cx from 'classnames';
import { useTranslation } from 'next-i18next';
import { CubeIcon } from '@heroicons/react/24/outline';
import Skeleton from '@common/Skeleton';
import Show from '@common_show';

const StockStatus = ({
    inStock = false,
    label,
    labelVariant = 'bd-2b',
    className,
    loading = false,
}) => {
    const { t } = useTranslation(['common']);
    let labelFinal = label;
    if (!label) {
        labelFinal = inStock ? t('common:cart:inStock') : t('common:cart:oos');
    }
    return (
        <div className={cx(
            'stock-status',
            'flex items-center',
            className,
        )}
        >
            <Show when={!loading}>
                <CubeIcon className="h-[15px] w-[15px] text-neutral-150" />
                <Typography variant={labelVariant} className="ml-[6px] !text-neutral-350">{labelFinal}</Typography>
            </Show>

            <Show when={loading}>
                <Skeleton width={80} height={24} />
            </Show>
        </div>
    );
};

export default StockStatus;
